import { createSlice } from "@reduxjs/toolkit";

const ReduxCardSlice = createSlice({
  name: "cards",
  initialState: {
    cardList: [],
  },
  reducers: {
    addCard: (state, action) => {
      state.cardList.push(action.payload);
    },
    removeCard: (state, action) => {
      state.cardList = state.cardList.filter(
        (card, index) => index !== action.payload
      );
    },
    resetCards: (state) => {
      state.cardList = [];
    },
  },
});

export const { addCard, removeCard, resetCards } = ReduxCardSlice.actions;
export default ReduxCardSlice.reducer;
